import React, {useState, useEffect} from 'react';
import { Table, Row, Col } from 'antd';
import BrandFilters from './BrandFilters';
import { customerStockBrands } from '../../../services/serviceReports';
import { ContainerTwoTone } from '@ant-design/icons';
import BrandChart from './BrandChart';

const BrandList = ({customer, baseDates}) => {
    const [tableData, setTableData] = useState([]);
    const [brand, setBrand] = useState();

    useEffect(() => getCustomerStockBrands(),[customer, baseDates])

    const getCustomerStockBrands = (brandId, dateRanges) => {
        let sDate = dateRanges?.length ? dateRanges[0] : baseDates[0];
        let eDate = dateRanges?.length ? dateRanges[1] : baseDates[1];

        setBrand(brandId);
        
        const requestObj = {
            customerId: customer,
            brandId: brandId || null,
            startDate: sDate,
            endDate: eDate
        };

        customerStockBrands(requestObj)
            .then(({data}) => {
                if(data) {
                    const organized = data.map((i, idx) => ({
                        rowKey: `customer-brand-${idx}`,
                        ...i
                    }));
                    setTableData(organized);
                }
            })
    };

    const updater = (brandId, dates) => getCustomerStockBrands(brandId, dates);

    const columns = [
        {
            title: 'Stok Adı',
            dataIndex: 'n',
            key: 'n',
            ellipsis: true
        },
        {
            title: 'Stok Kodu',
            dataIndex: 'c',
            key: 'c',
            ellipsis: true
        },
        {
            title: 'Adet',
            dataIndex: 'a',
            key: 'a'
        },
        {
            title: 'Para Birimi',
            dataIndex: 'cr',
            key: 'cr'
        },
        {
            title: 'Toplam Fiyat',
            dataIndex: 'lt',
            key: 'lt',
            render: (t) => new Intl.NumberFormat().format(t)
        }
    ];

    const shadowStyle = {
        boxShadow: '1px 2px 3px 1px rgba(0, 0, 0, 0.3)'
    };

    return(
        <React.Fragment>
                <Col span={9}>
                    <Row align={'middle'} style={{marginBottom: '16px'}}>
                        <ContainerTwoTone /><h4 style={{marginLeft: '6px', marginBottom: 0}}>Marka Raporlama</h4>
                    </Row>
                    <BrandFilters updateSignal={updater}/>
                    <Table rowKey={'rowKey'} columns={columns} dataSource={tableData} style={{marginTop: '16px'}} size={'middle'}/>
                </Col>
                <Col span={14} style={shadowStyle}>
                    <BrandChart data={tableData} isBrandSelected={brand}/>
                </Col>
        </React.Fragment>
    )
};

export default BrandList;
